import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const userActivityApi = createApi({
  reducerPath: "userActivityApi",
  tagTypes: ["MostRequested"],
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_BASE_URL}/users-report/`,
    prepareHeaders: (headers, { getState }) => {
      const cookies = document.cookie.split(";");
      let jwtCookie = null;

      cookies.forEach((cookie) => {
        const trimmedCookie = cookie.trim();
        if (trimmedCookie.startsWith("token=")) {
          jwtCookie = "Bearer " + trimmedCookie.split("token=")[1];
        }
      });

      if (jwtCookie) {
        headers.set("authorization", jwtCookie);
      }

      return headers;
    },
  }),
  endpoints: (builder) => ({

    mostSearchedMedications: builder.query({
      query: (page) => {
        let url = `most-search-medications?page=${page}`;
        return {
        url,
        method: "GET"
      }},
    }),
    mostRequestedMedications: builder.query({
      query: (page) => {
        let url = `most-requested-medications?page=${page}`;
        return {
        url,
        method: "GET"
      }},
      providesTags: ["MostRequested"],
    }),
    trendingSearches: builder.query({
      query: (page = 1) => {
        let url = `trending-searches?page=${page}`;
        return {
        url,
        method: "GET"
      }},
    }),
    trendingTvCommercials: builder.query({
      query: (page = 1) => {
        let url = `top-trending-tv-commercials?page=${page}`;
        return {
        url,
        method: "GET"
      }},
    }),

    trendingKeywordsByLocation: builder.query({
      query: () => {
        let url = 'trending-searches-by-users';
        return {
        url,
        method: "GET"
      }},
    }),
    getTrendingHealthNews: builder.query({
      query: () => {
        let url = 'get-trending-health-news';
        return {
        url,
        method: "GET"
      }},
    }),
    getProductsFromTitle: builder.query({
      query: (title) => {
        if (!title) return;
        let url = `get-video-sentence?title=${title}`;
        return {
        url,
        method: "GET"
      }},
    }),
  }),
});

export const {
    useMostSearchedMedicationsQuery,
    useMostRequestedMedicationsQuery,
    useTrendingSearchesQuery,
    useTrendingTvCommercialsQuery,
    useTrendingKeywordsByLocationQuery,
    useGetTrendingHealthNewsQuery,
  useGetProductsFromTitleQuery,

} = userActivityApi;
